import axios from "axios";
import config from "./configration/config";
import { APPLICATION_JSON, MULTIPART_DATA, LOGIN } from "../constants/Constant";
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorageUtils";
import { ACCESS_TOKKEN } from "../constants/LocalStorageKeyValuePairString";

const baseUrl = config.apiBaseUrl;
const baseUrlV2 = config.apiBaseUrlv2;
const oAuthBaseUrl = config.oAuthBaseUrl;
const reportsBaseUrl = config.downloadReportBaseUrl;


// Function to refresh token
let isRefreshing = false;
let failedRequestsQueue = [];


export const axiosInstance = axios.create({
  //baseURL: "https://cors-anywhere.herokuapp.com/" + baseUrl, // proxy server path attached TO BYPASS CORS
  baseURL: baseUrl, // IF API DO NOT HAVE CORS ISSUE
  timeout: 60000,
  headers: {
    "Content-Type": APPLICATION_JSON,
  },
});

export const axiosInstanceV2 = axios.create({
   //baseURL: "https://cors-anywhere.herokuapp.com/" + baseUrlV2, // proxy server path attached TO BYPASS CORS
   baseURL: baseUrlV2, // IF API DO NOT HAVE CORS ISSUE
   timeout: 60000,
   headers: {
     "Content-Type": APPLICATION_JSON,
   },
 });


export const oAuthAxiosInstance = axios.create({
  //baseURL: "https://cors-anywhere.herokuapp.com/" + oAuthBaseUrl, // proxy server path attached TO BYPASS CORS
  baseURL: oAuthBaseUrl, // IF API DO NOT HAVE CORS ISSUE
  timeout: 60000,
  headers: {
    "Content-Type": APPLICATION_JSON,
  },
});

 export const axiosInititateDownloadReportInstance = axios.create({
  // baseURL: "https://cors-anywhere.herokuapp.com/" + reportsBaseUrl,
   baseURL: reportsBaseUrl, 
   timeout: 60000,
   headers: {
     "Content-Type": APPLICATION_JSON,
   },
  // responseType: 'arraybuffer' // This is important as it tells axios to expect a binary response
 });


 export const axiosAttachmentDownloadInstance = axios.create({
  //baseURL: "https://cors-anywhere.herokuapp.com/" + baseUrl, // proxy server path attached TO BYPASS CORS
  baseURL: baseUrl, // IF API DO NOT HAVE CORS ISSUE
  timeout: 60000,
  headers: {
    "Content-Type": APPLICATION_JSON,
  },
  responseType: 'arraybuffer' // This is important as it tells axios to expect a binary response
});


export const axiosDownloadReportInstance = axios.create({
  // baseURL: "https://cors-anywhere.herokuapp.com/" + reportsBaseUrl,
   baseURL: reportsBaseUrl, 
   timeout: 60000,
   headers: {
     "Content-Type": APPLICATION_JSON,
   },
   responseType: 'arraybuffer' // This is important as it tells axios to expect a binary response
 });

 export const axiosMulitpartInstance = axios.create({
  // baseURL: "https://cors-anywhere.herokuapp.com/" + reportsBaseUrl,
   baseURL: reportsBaseUrl, 
   timeout: 60000,
   headers: {
     "Content-Type": MULTIPART_DATA,
   },
   //responseType: 'arraybuffer' // This is important as it tells axios to expect a binary response
 });



// Add a request interceptor
axiosMulitpartInstance.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
    // Do something before request is sent
    console.log("Request sent:", config);
    }
    const token = getFromLocalStorage(ACCESS_TOKKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    if (process.env.NODE_ENV === 'development') {
    // Do something with request error
    console.error("Request error:", error);
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosMulitpartInstance.interceptors.response.use(
  function (response) {
    if (response.data.responseCode !== "-1") {
      if (process.env.NODE_ENV === 'development') {
      
      console.log("Response received:", response);
      }
      return response;
    } else {
      if (process.env.NODE_ENV === 'development') {
      
      console.error("Response error:", response.data.displayErrorMessage);
      }
      return Promise.reject(response);
    }
  },
  async function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Response error:", error);
    }
    const originalRequest = error.config;

    if (error.response?.status === 401  && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        const newToken = await refreshToken();
        isRefreshing = false;
        originalRequest._retry = true;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        return new Promise((resolve) => {
          failedRequestsQueue.push((newToken) => {
            originalRequest._retry = true;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    return Promise.reject(error);
  }
);


 


// Add a request interceptor
axiosAttachmentDownloadInstance.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
    // Do something before request is sent
    console.log("Request sent:", config);
    }
    const token = getFromLocalStorage(ACCESS_TOKKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    if (process.env.NODE_ENV === 'development') {
    // Do something with request error
    console.error("Request error:", error);
    }
    return Promise.reject(error);
  }
);



// Add a response interceptor
axiosAttachmentDownloadInstance.interceptors.response.use(
  function (response) {
    if (response.data.responseCode !== "-1") {
      if (process.env.NODE_ENV === 'development') {
      
      console.log("Response received:", response);
      }
      return response;
    } else {
      if (process.env.NODE_ENV === 'development') {
      
      console.error("Response error:", response.data.displayErrorMessage);
      }
      return Promise.reject(response);
    }
  },
  async function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Response error:", error);
    }
    const originalRequest = error.config;

    if (error.response?.status === 401  && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        const newToken = await refreshToken();
        isRefreshing = false;
        originalRequest._retry = true;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        return new Promise((resolve) => {
          failedRequestsQueue.push((newToken) => {
            originalRequest._retry = true;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    return Promise.reject(error);
  }
);

// Add a request interceptor
axiosDownloadReportInstance.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
    // Do something before request is sent
    console.log("Request sent:", config);
    }
    const token = getFromLocalStorage(ACCESS_TOKKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    if (process.env.NODE_ENV === 'development') {
    // Do something with request error
    console.error("Request error:", error);
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosDownloadReportInstance.interceptors.response.use(
  function (response) {
    if (response.data.responseCode !== "-1") {
      if (process.env.NODE_ENV === 'development') {
      
      console.log("Response received:", response);
      }
      return response;
    } else {
      if (process.env.NODE_ENV === 'development') {
      
      console.error("Response error:", response.data.displayErrorMessage);
      }
      return Promise.reject(response);
    }
  },
  async function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Response error:", error);
    }
    const originalRequest = error.config;
  //&& error.response?.data.exp===ACCESS_TOKKEN_EXPIRED
    if (error.response?.status === 401  && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        const newToken = await refreshToken();
        isRefreshing = false;
        originalRequest._retry = true;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        return new Promise((resolve) => {
          failedRequestsQueue.push((newToken) => {
            originalRequest._retry = true;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    return Promise.reject(error);
  }
);


axiosInstanceV2.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
    console.log("Request sent:", config);
    }
    const token = getFromLocalStorage(ACCESS_TOKKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Request error:", error);
   }
    return Promise.reject(error);
  }
);







// Add a response interceptor
axiosInstanceV2.interceptors.response.use(
  function (response) {
    if (response.data.responseCode !== "-1") {
      if (process.env.NODE_ENV === 'development') {
      console.log("Response received:", response);
      }
      return response;
    } else {
      if (process.env.NODE_ENV === 'development') {
      
      console.error("Response error:", response.data.displayErrorMessage);
      }
      return Promise.reject(response);
    }
  },
  async function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Response error:", error);
    }
    const originalRequest = error.config;

    if (error.response?.status === 401  && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        const newToken = await refreshToken();
        isRefreshing = false;
        originalRequest._retry = true;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        return new Promise((resolve) => {
          failedRequestsQueue.push((newToken) => {
            originalRequest._retry = true;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    return Promise.reject(error);
  }
);





// Add a request interceptor
axiosInititateDownloadReportInstance.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
    console.log("Request sent:", config);
    }
    const token = getFromLocalStorage(ACCESS_TOKKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Request error:", error);
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosInititateDownloadReportInstance.interceptors.response.use(
  function (response) {
    if (response.data.responseCode !== "-1" ) {
      if (process.env.NODE_ENV === 'development') {
      console.log("Response received:", response);
      }
      return response;
    } else {
      if (process.env.NODE_ENV === 'development') {
      console.error("Response error:", response.data.displayErrorMessage);
      }
      return Promise.reject(response);
    }
  },
  async function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Response error:", error);
    }
    const originalRequest = error.config;

    if (error.response?.status === 401  && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        const newToken = await refreshToken();
        isRefreshing = false;
        originalRequest._retry = true;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        return new Promise((resolve) => {
          failedRequestsQueue.push((newToken) => {
            originalRequest._retry = true;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    return Promise.reject(error);
  }
);



// Add a request interceptor
axiosInstance.interceptors.request.use(
  function (config) {
    if (process.env.NODE_ENV === 'development') {
    console.log("Request sent:", config);
    }

    const token = getFromLocalStorage(ACCESS_TOKKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Request error:", error);
    }
    return Promise.reject(error);
  }
);

// Add a response interceptor
// axiosInstance.interceptors.response.use(
//   function (response) {
//     if (response.data.responseCode !== "-1" ) {
//       if (process.env.NODE_ENV === 'development') {
//       console.log("Response received:", response);
//       }
//       return response;
//     } else {
//       if (process.env.NODE_ENV === 'development') {
//       console.error("Response error:", response.data.displayErrorMessage);
//       }
//       return Promise.reject(response);
//     }
//   },
//   function (error) {
//     if (process.env.NODE_ENV === 'development') {
//     console.error("Response error:", error);
//     }
//     return Promise.reject(error);
//   }
// );

axiosInstance.interceptors.response.use(
  function (response) {
    if (response.data.responseCode !== "-1" ) {
      if (process.env.NODE_ENV === 'development') {
      console.log("Response received:", response);
      }
      return response;
    } else {
      if (process.env.NODE_ENV === 'development') {
      console.error("Response error:", response.data.displayErrorMessage);
      }
      return Promise.reject(response);
    }
  },
  async function (error) {
    if (process.env.NODE_ENV === 'development') {
    console.error("Response error:", error);
    }
    const originalRequest = error.config;

    if (error.response?.status === 401  && !originalRequest._retry) {
      if (!isRefreshing) {
        isRefreshing = true;
        const newToken = await refreshToken();
        isRefreshing = false;
        originalRequest._retry = true;
        originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(originalRequest);
      } else {
        return new Promise((resolve) => {
          failedRequestsQueue.push((newToken) => {
            originalRequest._retry = true;
            originalRequest.headers["Authorization"] = `Bearer ${newToken}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }
    return Promise.reject(error);
  }
);


const refreshToken = async () => {
  try {
    // const response = await axios.post("/auth/refresh-token", {
    //   refreshToken: localStorage.getItem("refreshToken"),
    // });
   const tokenApiKey = process.env.REACT_APP_O_AUTH_TOKKEN_API_KEY;
    const formData = new URLSearchParams();
    formData.append("client_id", process.env.REACT_APP_O_AUTH_CLIENT_ID);
    formData.append("client_secret",  process.env.REACT_APP_O_AUTH_CLIENT_SECRET);
    formData.append("grant_type", process.env.REACT_APP_O_AUTH_GRANT_TYPE);

        const response = await axios.post(config.oAuthBaseUrl, formData, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            apikey: tokenApiKey,
          },
        });

    const newToken = response.data.accessToken;
     saveToLocalStorage(ACCESS_TOKKEN, response.data.access_token);
    
    // Retry failed requests
    failedRequestsQueue.forEach((callback) => callback(newToken));
    failedRequestsQueue = [];

    return newToken;
  } catch (error) {
    console.error("Refresh token failed:", error);
    failedRequestsQueue = [];
     
     localStorage.removeItem("accessToken");
    window.location.href = LOGIN; // Redirect to login
  }
};


// Remove the interceptors when no longer needed (e.g., when component unmounts)
// instance.interceptors.request.eject(requestInterceptor);
// instance.interceptors.response.eject(responseInterceptor);
